import "./WhyChooseUs.css";
import WhyChooseCard from "./WhyChooseCard";

import {
    Zap,
    Code2,
    Headphones,
    TrendingUp
} from "lucide-react";

const WhyChooseUs = () => {
    return (
        <section className="why-choose-us">

            <div className="why-container">

                <div className="why-header">
                    <span className="why-badge">WHY US</span>

                    <h2>
                        Why Choose <span>Shirdhankar Technologies</span>
                    </h2>

                    <p>
                        We focus on quality, innovation and long-term partnerships to
                        deliver solutions that make an impact.
                    </p>
                </div>

                <div className="why-grid">

                    <WhyChooseCard
                        icon={Zap}
                        title="Fast Delivery"
                        description="Rapid development cycles with clean, production-ready code delivered on time."
                    />

                    <WhyChooseCard
                        icon={Code2}
                        title="Modern Tech Stack"
                        description="Built using React, Node.js, Unity and the latest technologies for scalable solutions."
                    />

                    <WhyChooseCard
                        icon={Headphones}
                        title="Dedicated Support"
                        description="Continuous communication, updates and post-launch support whenever you need it."
                    />

                    <WhyChooseCard
                        icon={TrendingUp}
                        title="Scalable Solutions"
                        description="Future-ready architecture designed to grow with your business and evolving needs."
                    />

                </div>

            </div>

        </section>
    );
};

export default WhyChooseUs;